/* eslint-disable */
export default {
  sureToDeleteVoiceMail: '确定要删除此语音邮件吗？',
  sureToDeleteFax: '确定要删除此传真吗？',
  doNotAskAgain: '不再询问我',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
